var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile",style:({ width: (_vm.size + "px"), height: (_vm.size + "px") }),on:{"click":function($event){_vm.$emit('get-project-name', _vm.alt)}}},[_c('img',{staticClass:"tile__image",attrs:{"src":_vm.src,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }